import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LoadingSpinner } from '@ui/components'

import { useMessageContext } from '../../modules/Message'
import { useAppContext } from '~/contexts'
import { useChatContext } from '@ui/chat/ChatProvider'
import { ChatMessage } from '@types'

export default function ArtifactCard({ id }: { readonly id: string }) {
	const { message } = useMessageContext()
	const { setIsSidebarCollapsed } = useAppContext()
	const { chatDispatch } = useChatContext()

	const artifact = message.artifacts?.find(artifact => artifact.id === id)

	if (!id) {
		return null
	}

	function handleClick() {
		if (artifact) {
			if (artifact) {
				chatDispatch({ type: 'setArtifactParams', artifactParams: {
					artifact: artifact,
					artifactMessage: message as ChatMessage,
				} })
	
				if (message.selectedBrains) {
					chatDispatch({ type: 'setSelectedBrains', brains: message.selectedBrains })
				}
	
				chatDispatch({ type: 'setSelectedOpenBrain', brain: undefined })
				setIsSidebarCollapsed(true)
			} else {
				chatDispatch({ type: 'setArtifactParams', artifactParams: undefined })
			}
		}
	}

	const isLoading = artifact && !artifact.name

	return (
		<button
			className="relative flex py-1 mt-4 rounded-2xl bg-gray-100 transition-all border border-gray-200 items-stretch"
			onClick={ handleClick }
		>
			<div className="px-4 border-r border-gray-200 flex justify-center items-center">
				{
					isLoading ? (
						<LoadingSpinner style="gray" size="small" />
					) : (
						<FontAwesomeIcon icon="file-alt" className="text-2xl text-gray-500" />
					)
				}
			</div>
			<div className="flex flex-col justify-center px-4 text-left relative">
				<div className="font-bold line-clamp-2">
					{ isLoading ? 'Loading...' : artifact?.name }
				</div>
				<div className="text-sm text-gray-500">
					Click to open
				</div>
			</div>
		</button>
	)
}
